import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const CITY_VIDEO_REPORT_ID = `city${VIDEO_CAMPAIGN_SUFFIX}`;
